export enum StateClient {
	POTENCIAL = 'Potencial',
	ACTIVO = 'Activo',
	INACTIVO = 'Inactivo',
}
